var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{class:_vm.$style.wrapper,style:({ transform: _vm.transform }),attrs:{"preserveAspectRatio":"none","viewBox":"0 0 1440 800"},on:{"mousemove":_vm.setMousePos}},[_c('path',{ref:"path",attrs:{"d":_vm.path}})])}
var staticRenderFns = []

export { render, staticRenderFns }